module.exports = __webpack_public_path__ + "img/subscribers.b601f2e4.svg";